module.exports = __webpack_public_path__ + "img/advertInformation.c70290bd.png";